import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TriangleAlert } from 'lucide-react';
import logo from '../../assets/images/logo-win-white.svg';
import '../../assets/css/login.css';

const SessionExpire = () => {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    // Optionally clear storage or reset state here
    navigate('/');
  };

  return (
    <div className="body-style">
      <div className="login-page">
        <header className="top-logo">
          <img src={logo} alt="Logo" />
        </header>

        <div className="login-container full-width">
          <div className="login-form" style={{ textAlign: 'center' }}>
            <h1 style={{ color: '#ec088c' }}>
              <TriangleAlert size={32} style={{ verticalAlign: 'middle', marginBottom: '4px' }} />
              &nbsp;Session Expired
            </h1>
            <p style={{ marginTop: '10px', fontSize: '18px', fontWeight: 600 }}>
              Your session has expired
            </p>
            <p style={{ color: '#555', fontSize: '16px', marginTop: '10px', lineHeight: '1.6' }}>
              
              Please return to Login Page.
            </p>
            <button
              type="button"
              onClick={handleBackToLogin}
              style={{
                marginTop: '20px',
                padding: '10px 20px',
                backgroundColor: '#ec088c',
                border: 'none',
                borderRadius: '5px',
                color: '#fff',
                fontSize: '16px',
                cursor: 'pointer',
              }}
            >
              Return to Login Page
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionExpire;